// The unnamed creature-head artifact introduced in the quarry opening.
export function creatureArtifact(r,x,y,angle=0,{lit=0}={}){
 const c=r.ctx;c.save();c.translate(x,y);c.rotate(angle);
 r.path([[-6,-3],[-7,-8],[-3,-6],[0,-7],[3,-6],[7,-8],[6,-3],[7,1],[4,6],[0,7],[-4,6],[-7,1]],'#7b9791','#263f46',.85);
 r.path([[-6,-3],[-3,-5],[0,-4],[3,-5],[6,-3],[4,-1],[-4,-1]],'#a2b0a0');
 r.path([[-6,-1],[-3,0],[-4,4],[-1,6],[-4,5],[-6,2]],'#526f70');
 r.path([[-2,2],[0,1],[2,2],[3,4],[0,5],[-3,4]],'#b0b5a0','#526967',.55);
 r.line(-1,3,1,3,'#314d52',.65);r.line(0,4,0,5.5,'#526c6b',.6);
 for(const eye of [-3.1,3.1]){r.circle(eye,-.7,1.7,'#243f49','#566e70',.5);if(lit){c.save();c.globalAlpha=lit;r.circle(eye,-.7,1.25,'#ffe3a0');r.circle(eye-.25,-1,.5,'#fff8d3');c.restore();}}
 r.line(-4,-5,-2,-5.5,'#d1ceb0',.55);r.line(3,3,4.3,1.6,'#5c7977',.6);c.restore();
}
